/** @enum {CourseConflictEnum} */

export const CourseConflictEnum = {
  PREREQ_MISS: {
    id: 'PREREQ_MISS',
    template:
      'One (or more) of these prerequisites need to be added to an earlier term. Click the course name for more details'
  },
  PREREQ_OUTOFORDER: {
    id: 'PREREQ_OUTOFORDER',
    template:
      'One (or more) of these prerequisites need to be added to an earlier term. Click the course name for more details'
  },
  COREQ_MISS: {
    id: 'COREQ_MISS',
    template:
      'One (or more) of these co-requisites need to be added to the same term as this course. Click the course name for more details'
  },
  COREQ_OUTOFORDER: {
    id: 'COREQ_OUTOFORDER',
    template:
      'One (or more) of these co-requisites need to be added to the same term as this course. Click the course name for more details'
  }
};



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/types/course_conflict_enum.ts